/**
 * Formato de fecha/hora para ventas: "YYYY-MM-DD HH:mm"
 * @param {string|Date|null|undefined} val
 * @returns {string}
 */
export function formatFechaVentas(val) {
  if (val == null || val === "") return "—";
  const d = new Date(val);
  if (Number.isNaN(d.getTime())) return "—";
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
